import type { FinishResult, Outcome, SigningTransport } from "./types.ts"

type Post = <T>(path: string, body: unknown) => Promise<Outcome<T>>

/** What each door posts the same way, relative to its own signing root. */
export const fieldActions = (
  post: Post
): Pick<SigningTransport, "completeField" | "finish" | "decline"> => ({
  completeField: (fieldId, value) =>
    post(`fields/${fieldId}/complete/`, value === undefined ? {} : { value }),
  finish: () => post<FinishResult>("finish/", {}),
  decline: (reason) => post("decline/", { reason })
})
